<template>
  <audio
    class="audio"
    controls
    :src="audioUrl"
  >
    Your browser does not support the
    <code>audio</code> element.
  </audio>
</template>
<script>
export default {
  props: {
    audioUrl: String
  }
}
</script>
<style lang="less" scoped>
.audio {
  width: 300px;
  height: 100%;
  min-height: 44px;
  display: inline-block;
}
</style>